import * as constActions from './const';
import initialState from './initialState';

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case constActions.UPDATE_USERS_SUCCESS:
      return Object.assign({}, state, {
        users: action.users
      });
    case constActions.GET_IS_MFA_ENABLED_SUCCESS:
      return Object.assign({}, state, {
        isMfaEnabled: action.isMfaEnabled
      });
    case constActions.GET_IS_ADD_USERNAME_IN_EMAIL_FORMAT_SUCCESS:
      return Object.assign({}, state, {
        isAddUsernameInEmailFormat: action.isAddUsernameInEmailFormat
      });
    case constActions.GET_USER_ROLES_SUCESS:
      return Object.assign({}, state, {
        userRoles: action.roles
      });
    case constActions.ADD_ROLE_SUCESS:
      return Object.assign({}, state, {
        userRoles: [...state.userRoles, action.role]
      });
    case constActions.UPDATE_USER_ROLE_SUCESS:
      return Object.assign({}, state, {
        users: state.users.map(r => {
          if (r.userId == action.user.userId) {
            return action.user;
          } else {
            return r;
          }
        })
      });
    case constActions.UPDATE_ROLE_PERMISSIONS_SUCESS:
      return Object.assign({}, state, {
        userRoles: state.userRoles.map(r => (r.RoleId === action.role.RoleId ? action.role : r))
      });
    case constActions.REMOVE_ROLE_SUCESS:
      return Object.assign({}, state, {
        userRoles: state.userRoles.filter(r => r.RoleId != action.roleId)
      });
    case constActions.UPDATE_ROLE_SITES_SUCESS:
      return Object.assign({}, state, {
        userRoles: state.userRoles.map(r => (r.RoleId === action.role.RoleId ? action.role : r))
      });
    default:
      return state;
  }
}
